import { authRequest } from './index.js'

export async function get_total_reward(){
  let data
  await authRequest.get(
    'reward_histories/total'
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function get_histories(){
  let data
  await authRequest.get(
    'reward_histories'
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}